// extracted by mini-css-extract-plugin
export default {"Badge":"badge_Badge__OHDl4","Badge__answered":"badge_Badge__answered__dmuJw","Badge__unanswered":"badge_Badge__unanswered__Lsjzf"};